function isMobile() {
  return (
    typeof window === 'object' &&
    !!window.navigator.userAgent
      .toLocaleLowerCase()
      .match(/(mobile|iemobile|android|webos|iphone|ipad|ipod|blackberry|windows phone)/)
  );
}

export default isMobile();
